var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "navBar"
  }, [_c('el-dropdown', {
    staticClass: "userMsg",
    attrs: {
      "hide-on-click": false
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link "
  }, [_vm._v("\n        " + _vm._s(_vm.user)), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "setting"
    }
  }, [_vm._v("设置")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "loginOut",
      "divided": ""
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1), _vm._v(" "), _c('Levelbar')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3ecfe8a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Navbar.vue
// module id = PxTB
// module chunks = 1